module.exports = new __parcel__URL__("odiac-ffco2-monthgrid-v2022.thumbnails.co2.acc3a2c0.png").toString();